import BaseFormPresenter from "../../../../base/BaseFormPresenter";

class DisbursementFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }
}

export default DisbursementFormPresenter;
